export default {
    parts: [],
    baseStyle: (props) => ({
        container: {
            position: 'relative',
            ...(props.HeroSize !== 'full bleed' && {
                maxWidth: { lg: 'container.xxxl' },
                margin: '0 auto'
            })
        },
        wrapper: {
            position: 'relative'
        },
        customNavigation: {
            position: 'absolute',
            right: '24px',
            bottom: '63px',
            color: 'white',
            maxWidth: '342px',
            color: props?.currentTitleColor || 'black',
            width: '100%',
            zIndex: 1
        },
        nextUp: {
            fontSize: 'xs',
            fontWeight: 'bold',
            textTransform: 'uppercase',
            marginBottom: '10px'
        },
        titleAndControls: {
            display: 'flex',
            justifyContent: 'space-between',
            gap: 4,
            marginBottom: 5
        },
        nextTitle: {
            fontSize: 'md',
            fontWeight: 'bold',
            lineHeight: '20px',
            textTransform: 'uppercase'
        },
        controlsWrapper: {
            display: 'flex',
            flexWrap: 'no-wrap',
            alignItems: 'center',
            gap: 1
        },
        arrow: {
            cursor: 'pointer',
            '& .custom-arrow': {
                _hover: {
                    backgroundColor: 'white',
                    '& path': {
                        stroke: 'black'
                    }
                }
            }
        },
        rightArrow: {
            transform: 'rotate(180deg)'
        },
        controls: {
            position: 'absolute',
            top: { base: '20px', lg: '24px' },
            right: { base: '32px', lg: '48px' },
            zIndex: '1'
        },
        control: {
            cursor: 'pointer',
            width: { base: '40px', lg: '32px' },
            height: { base: '40px', lg: '32px' }
        }
    }),
}
